import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import VueCountryIntl from "../stempcore/src/lib/_vue-country-intl@1.1.9@vue-country-intl/lib/vue-country-intl.min";
import "../stempcore/src/lib/_vue-country-intl@1.1.9@vue-country-intl/lib/vue-country-intl.css";

Vue.use(Antd);

import { SExtraFilter } from "../stempcore/src/core/sextra";
Vue.use(SExtraFilter);

import "./assets/scss/index.scss";

Vue.config.productionTip = false;

import { SkFieldsComponents } from "../stempcore/src/core/sfield";
Vue.use(SkFieldsComponents);

import { URLS } from "fire-wind-water";
import service from "./service/form";

window.$sk.Text.prototype.sendCode = function (key, o) {
  this.messages.sendCode = "请输入手机号";
  this.dirty = true;
  if (this.invalid) {
    return;
  }
  if (!this.value) {
    this.error.sendCode = true;
    this.hasError();
    return;
  }
  this.error.sendCode = false;
  this.sendCodeJson.time = 60;
  this.sendCodeJson.disabled = true;
  this.sendCallback(this);
  service
    .sendCheckCode({
      globalUserId: window.$sk.template.get().user.globalUserId,
      mobile: this.areaCode ? this.areaCode + this.value : this.value,
      customFormId: URLS.getURL("customFormId") || URLS.getHash("customFormId"),
      instanceId: window.$sk.template.get().common.instanceId,
      ...o,
    })
    .subscribe((res) => {
      if (res.result !== 0) {
        window.$sk.alert(res.desc);
        this.sendCodeJson.time = 0;
        this.sendCodeJson.disabled = false;
        this.sendCallback(this);
      } else {
        this.sendWaiting();
      }
    });
};

import { interact } from "fire-wind-water";
Vue.component(VueCountryIntl.name, VueCountryIntl);
Vue.mixin({
  methods: {
    pxOrVw(value) {
      let newValue;
      if (interact.isMobile || this.platform == "wap") {
        if (value > 2) {
          newValue = value / 7.5 + "vw";
        } else {
          newValue = "1px";
        }
      } else {
        newValue = value + "px";
      }
      return newValue;
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
